import { getIssueStateFilterValueOptions } from '../../valueOptions';
import { createFixedOptionsFilterInput } from '../common';

export const IssueStateFilterInput = createFixedOptionsFilterInput(
  getIssueStateFilterValueOptions
);
